const miniQuests = [
  {
    id: 1,
    description: 'Selesaikan 1 soal apapun',
    reward: 5,
    acquired: false,
  },
  {
    id: 2,
    description: 'Dapatkan 10XP',
    reward: 10,
    acquired: false,
  },
  {
    id: 3,
    description: 'Selesaikan 1 quest',
    reward: 15,
    acquired: false,
  },
]

export default miniQuests